<template>
  <div class="intake-content">
    <div v-if="selectedRoom">
      <div class="mb-2">
        <label for="room_name" class="sr-only">
          Kamernaam
        </label>

        <input
          class="intake-content__room intake__heading form-control"
          type="text"
          id="room_name"
          :value="selectedRoom.title"
          @input="(e) => updateRoomField([selectedRoom, 'title', e.target.value])"
        >
      </div>

      <div class="form-group">
        <label>
          Objecten
        </label>

        <div v-if="selectedRoom.objects && selectedRoom.objects.length">
          <IntakeObject
            v-for="(object, objectIndex) in selectedRoom.objects"
            :key="objectIndex + selectedRoomIndex"
            :index="objectIndex"
            :object="object"
          />
        </div>

        <div class="d-flex">
          <div class="custom-select flex-grow-1 mr-1">
            <select v-model="selectedObjectId">
              <option value="">Selecteer object</option>

              <option
                v-for="objectTemplate in objectTemplates"
                :key="objectTemplate.id"
                :value="objectTemplate.id"
              >
                {{ objectTemplate.name }} ({{ objectTemplate.size }})
              </option>
            </select>
          </div>

          <button
            class="btn btn--primary btn--sm"
            type="button"
            @click="() => onAddObjectClick(selectedObjectId, selectedRoom)"
          >
            Toevoegen
          </button>
        </div>
      </div>

      <IntakeUpload />

      <div v-if="currentSite !== 'inboedelopslag'">
        <div class="cms-content capped-xs mt-3 mt-lg-4">
          <label class="d-block">Verpakkingsmaterialen</label>
          Hoeveel van onderstaande verpakkingsmaterialen denkt u nodig te hebben voor deze ruimte?
        </div>

        <div class="row row--tight-gutters my-3">
          <div class="col-md-6 col-xl-4 mb-3 mb-md-0">
            <div class="form-group">
              <label for="book_boxes">
                Boekendozen
              </label>

              <input
                class="form-control"
                type="number"
                id="bookBoxes"
                step="5"
                :value="selectedRoom.bookBoxes"
                @input="(e) => updateRoomField([selectedRoom, 'bookBoxes', e.target.value])"
              >
            </div>
          </div>

          <div class="col-md-6 col-xl-4 mb-3 mb-md-0">
            <div class="form-group">
              <label for="move_boxes">
                Verhuisdozen
              </label>

              <input
                class="form-control"
                type="number"
                id="move_boxes"
                step="5"
                :value="selectedRoom.moveBoxes"
                @input="(e) => updateRoomField([selectedRoom, 'moveBoxes', e.target.value])"
              >
            </div>
          </div>

          <div class="col-md-6 col-xl-4 mb-3 mb-md-0">
            <div class="form-group">
              <label for="mattress_covers_1p">
                Matrashoezen 1P
              </label>

              <input
                class="form-control"
                type="number"
                id="mattress_covers_1p"
                step="5"
                :value="selectedRoom.mattress_covers_1p"
                @input="(e) => updateRoomField([selectedRoom, 'mattress_covers_1p', e.target.value])"
              >
            </div>
          </div>

          <div class="col-md-6 col-xl-4 mb-3 mb-md-0">
            <div class="form-group">
              <label for="mattress_covers_2p">
                Matrashoezen 2P
              </label>

              <input
                class="form-control"
                type="number"
                id="mattress_covers_2p"
                step="5"
                :value="selectedRoom.mattress_covers_2p"
                @input="(e) => updateRoomField([selectedRoom, 'mattress_covers_2p', e.target.value])"
              >
            </div>
          </div>
        </div>
      </div>

      <div class="d-flex justify-content-end">
        <button
          type="button"
          class="btn btn--sm"
          @click="() => removeRoom(selectedRoomIndex)"
        >
          Verwijder kamer
        </button>
      </div>
    </div>

    <div class="my-auto font-weight-bold text-center lg-font-size-lg" v-else>
      Er zijn nog geen kamers
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import IntakeObject from '@/intake/components/IntakeObject.vue';
import IntakeUpload from '@/intake/components/IntakeUpload.vue';

export default {
  components: {
    IntakeObject,
    IntakeUpload,
  },

  data() {
    return {
      selectedObjectId: '',
    };
  },

  computed: {
    ...mapGetters({
      currentSite: 'currentSite',
      selectedRoom: 'room/selectedRoom',
      selectedRoomIndex: 'room/selectedRoomIndex',
      objectTemplates: 'room/objectTemplates',
    }),
  },

  methods: {
    ...mapMutations({
      updateRoomField: 'room/updateRoomField',
      removeRoom: 'room/removeRoom',
      addObjectToRoom: 'room/addObjectToRoom',
    }),

    onAddObjectClick(selectedObjectId, selectedRoom) {
      this.addObjectToRoom([selectedObjectId, selectedRoom])

      this.selectedObjectId = '';
    },
  },
};
</script>
